import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=8387ccc2&scoped=true&lang=pug&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=8387ccc2&lang=scss&scoped=true&"
import style1 from "./Detail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8387ccc2",
  null
  
)

export default component.exports